/** @file Dirty-layer scheduler. Draws only dirty layers on the next rAF tick. */

/** @type {Set<import("konva/lib/Layer.js").Layer>} */
const dirty = new Set();
let scheduled = false;

/**
 * Mark a layer dirty. It will redraw on the next animation frame.
 * @param {import("konva/lib/Layer.js").Layer} layer
 */
export function markDirty(layer) {
  dirty.add(layer);
  if (!scheduled) {
    scheduled = true;
    requestAnimationFrame(flush);
  }
}

function flush() {
  scheduled = false;
  for (const layer of dirty) {
    layer.batchDraw();
  }
  dirty.clear();
}
